module.exports = __webpack_public_path__ + "static/media/zbar.wasm.5f90df22.bin";